import actions from '../../../constants/actionTypes';
import { getDate } from '../../../utils/utils';
import { EnumOrderGroupStatus, EnumOrderListFilter, EnumPage } from '../../../constants/enum';
import {
  handleChangeTableActivePage,
  handleChangeTablePageSize,
  handleCloseDialogGeneric,
  handleOpenDialogGeneric,
} from '../../../redux/genericReducerHandler';
import { COMMON_CONST } from '../../../constants/constants';

const initialState = {
  filters: {
    fromDate: getDate(),
    toDate: getDate(),
    orderCode: '',
    status: {
      value: EnumOrderGroupStatus.PROCESSING.id,
      label: EnumOrderGroupStatus.PROCESSING.description,
    },
    filter: {
      value: EnumOrderListFilter.ALL.id,
      label: EnumOrderListFilter.ALL.description,
    },
    isAutoReload: true,
    sortInfo: {
      sort: null,
      sortOrder: null,
    },
  },
  table: {
    itemList: [],
    itemData: {},
    activePage: 1,
    pageSize: COMMON_CONST.PageSize,
  },
  dialog: {
    isOpenDialog: false,
    itemDetail: {},
    nextOpenTime: getDate(),
    itemDish: {},
  },
};

function orderReducer(state = initialState, action) {
  const { response, type } = action;
  const PAGE = EnumPage.ORDER_MANAGEMENT.id;
  switch (type) {
    case actions.OPEN_DIALOG_GENERIC: {
      return handleOpenDialogGeneric(PAGE, state, action);
    }

    case actions.CLOSE_DIALOG_GENERIC: {
      return handleCloseDialogGeneric(PAGE, state, action);
    }

    case actions.CHANGE_TABLE_ACTIVE_PAGE: {
      return handleChangeTableActivePage(PAGE, state, action);
    }

    case actions.CHANGE_TABLE_PAGE_SIZE: {
      return handleChangeTablePageSize(PAGE, state, action);
    }

    case actions.CHANGE_FILTER_ORDER_MANAGEMENT: {
      const mFilters = Object.keys(response).reduce(
        (filters, filterKey) => ({
          ...filters,
          [filterKey]:
            response[filterKey] !== null && response[filterKey] !== undefined
              ? response[filterKey]
              : initialState.filters[filterKey],
        }),
        {},
      );
      return {
        ...state,
        filters: {
          ...state.filters,
          ...mFilters,
        },
      };
    }

    case actions.RECEIVE_LIST_ORDER_MANAGEMENT_IDS: {
      const { itemList, itemData } = response;
      return {
        ...state,
        table: {
          ...state.table,
          activePage: 1,
          itemList,
          itemData,
        },
      };
    }

    case actions.RECEIVE_LIST_ORDER_MANAGEMENT_INFOS: {
      const { itemData } = response;
      return {
        ...state,
        table: {
          ...state.table,
          itemData: {
            ...state.table.itemData,
            ...itemData,
          },
        },
      };
    }

    case actions.RECEIVE_ORDER_DETAIL: {
      const { itemDetail } = response;
      return {
        ...state,
        dialog: {
          ...state.dialog,
          isOpenDialog: true,
          itemDetail,
        },
      };
    }

    case actions.RECEIVE_RESTAURANT_NEXT_OPEN_TIME: {
      const { nextOpenTime } = response;
      return {
        ...state,
        dialog: {
          ...state.dialog,
          nextOpenTime,
        },
      };
    }

    case actions.SET_EDIT_DISH_OUT_OF_STOCK: {
      const { itemDish } = response;
      return {
        ...state,
        dialog: {
          ...state.dialog,
          itemDish,
        },
      };
    }

    default:
      return state;
  }
}

export default orderReducer;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/reducers.js